/**
 * DamageType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file DamageType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum DamageType {
  BLUDGEONING = 0,
  PIERCING    = 1,
  SLASHING    = 2,
  UNIVERSAL   = 3,
  ACID        = 4,
  COLD        = 5,
  LIGHT_SIDE  = 6,
  ELECTRICAL  = 7,
  FIRE        = 8,
  DARK_SIDE   = 9,
  SONIC       = 10,
  ION         = 11,
  ENERGY      = 12,
  // POISON      = 13,
  BASE        = 13,
  PHYSICAL    = 14,
};